import type { MutationKey, QueryKey } from "@tanstack/react-query"

import type { ICoachRatingTypeDto } from "@/3514/types"

const ELogoutMutationKey: () => MutationKey = (): MutationKey => ["Logout"] as const
const ELogoutMutationUrl: () => string = (): string => "/api/user/logout/" as const

//

const ECoachInfoQueryKey: (params: { participantId: number }) => QueryKey = (params: {
    participantId: number
}): QueryKey => ["CoachInfo", `participantId:${params.participantId}`] as const
const ECoachInfoQueryUrl: (params: { participantId: number }) => string = (params: { participantId: number }): string =>
    `/api/participants/coach-info/?participant_id=${params.participantId}` as const

//

const ECoachingSessionsIndividualQueryKey: (params: { participantId: number }) => QueryKey = (params: {
    participantId?: number
}): QueryKey => {
    return ["CoachingSessions_Individual", `participantId:${params.participantId}`]
}
const ECoachingSessionsIndividualQueryUrl: (params: { participantId: number }) => string = (params: {
    participantId?: number
}): string => {
    return `/api/coach-session/by-participant/${params.participantId}/`
}

const ECoachingSessionsGroupQueryKey: (params: { groupId: number }) => QueryKey = (params: {
    groupId: number
}): QueryKey => {
    return ["CoachingSessions_Group", `groupId:${params.groupId}`]
}

const ECoachingSessionsGroupQueryUrl: (params: { groupId: number }) => string = (params: {
    groupId: number
}): string => {
    return `/api/coach-session/by-group/${params.groupId}/`
}

//

const EProductTypeQueryKey: () => QueryKey = (): QueryKey => ["ProductType"] as const
const EProductTypeQueryUrl: () => string = (): string => "/api/product-type/" as const

//

const ECoachRatingQueryKey: (params: { type: ICoachRatingTypeDto; participantId: number }) => QueryKey = (params: {
    type: ICoachRatingTypeDto
    participantId: number
}): QueryKey => ["CoachRating", `type:${params.type}`, `participantId:${params.participantId}`] as const
const ECoachRatingQueryUrl: (params: { type: ICoachRatingTypeDto; participantId: number }) => string = (params: {
    type: ICoachRatingTypeDto
    participantId: number
}): string =>
    `/api/participant-feedback-coach/questions/${params.type}/?participant_id=${params.participantId}` as const

//

const EUserQueryKey: () => QueryKey = (): QueryKey => ["User"] as const
const EUserQueryUrl: () => string = (): string => "/api/user/me/" as const

//

const EParticipantByIdQueryKey: (userId: number) => QueryKey = (userId: number): QueryKey =>
    ["Participant", userId] as const
const ESocialLoginQueryKey: () => QueryKey = (): QueryKey => ["SocialComplete"] as const

//

const ESocialLoginQueryUrl: () => string = (): string => "/api/user/social/complete/" as const
const EParticipantByIdQueryUrl: (userId: number) => string = (userId: number): string =>
    `/api/participants/${userId}/` as const

export {
    ELogoutMutationKey,
    ELogoutMutationUrl,
    //
    ECoachInfoQueryKey,
    ECoachInfoQueryUrl,
    //
    ECoachingSessionsIndividualQueryKey,
    ECoachingSessionsIndividualQueryUrl,
    //
    ECoachingSessionsGroupQueryKey,
    ECoachingSessionsGroupQueryUrl,
    //
    EProductTypeQueryKey,
    EProductTypeQueryUrl,
    //
    ECoachRatingQueryKey,
    ECoachRatingQueryUrl,
    //
    EUserQueryKey,
    EUserQueryUrl,
    //
    EParticipantByIdQueryKey,
    EParticipantByIdQueryUrl,
    //
    ESocialLoginQueryKey,
    ESocialLoginQueryUrl
}
